export const triggerPage = (name, data = {}) => {
  if (process.env.NODE_ENV !== "production") {
    console.log(name, data);
  }

  if (
    process.env.NODE_ENV === "production" &&
    process.env.REACT_APP_STYLE !== "ac"
  ) {
    window.analyticsService.sendViewEvent(name, data);
  }
};

export const triggerLink = (name, data) => {
  if (process.env.NODE_ENV !== "production") {
    console.log(name, data);
  }

  if (
    process.env.NODE_ENV === "production" &&
    process.env.REACT_APP_STYLE !== "ac"
  ) {
    window.analyticsService.sendLinkEvent(name, data);
  }
};

export const pageLoad = (lang) => {
  triggerPage("GenderbiasDecoderView");
};

const buttonClick = (name, type) => {
  const data = {
    events: ["buttonClick"],
    pageButtonType: type,
  };

  triggerLink(name, data);
};

export const undo = () =>
  buttonClick("GenderbiasDecoderUndoButtonClick", "undo");
export const redo = () =>
  buttonClick("GenderbiasDecoderRedoButtonClick", "redo");
export const clear = () =>
  buttonClick("GenderbiasDecoderClearButtonClick", "clear");

export const replaceText = (phrase, replacement) => {
  const data = {
    events: ["buttonClick"],
    pageButtonType: "replace",
    genderbiasDecoderReplacedText: `${phrase}|${replacement}`,
  };

  triggerLink("GenderbiasDecoderReplaceClick", data);
};

export const removeText = (phrase) => {
  const data = {
    events: ["buttonClick"],
    pageButtonType: "delete",
    genderBiasDecoderReplacedText: `${phrase}`,
  };

  triggerLink("GenderbiasDecoderDeleteClick", data);
};

export const textPaste = () => {
  const data = {
    events: ["textPaste"],
  };

  triggerLink("GenderbiasDecoderPasteText", data);
};

export const apiResponse = (response_id, metrics) => {
  const {
    amount_of_bias,
    bias_balance_score,
    female_coded_count,
    female_per_100_score,
    male_coded_count,
    male_per_100_score,
    mf_ratio_score,
    text_length,
  } = metrics;

  const responseShort = `${amount_of_bias}_${bias_balance_score}_${female_coded_count}_${female_per_100_score}_${male_coded_count}_${male_per_100_score}_${mf_ratio_score}_${text_length}`;

  const data = {
    events: ["apiResponseReceived"],
    genderbiasDecoderApiId: response_id,
    genderbiasDecoderApiResponse: responseShort,
  };

  triggerLink("GenderbiasDecoderApiResponse", data);
};

const tracking = {
  pageLoad,
  textPaste,
  redo,
  undo,
  clear,
  replaceText,
  apiResponse,
  removeText,
};

export default tracking;
